import { render } from "./TheLoading.vue?vue&type=template&id=5efd9835&scoped=true&ts=true"
import script from "./TheLoading.vue?vue&type=script&lang=ts"
export * from "./TheLoading.vue?vue&type=script&lang=ts"

import "./TheLoading.vue?vue&type=style&index=0&id=5efd9835&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efd9835"]])

export default __exports__